<template>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <Button @click="redirectionAjouterMarque"> Ajouter</Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer</Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['fermer', 'addMarqueFromList'],
  data() {
    return {
      marque: null,
    }
  },
  methods: {
    redirectionAjouterMarque() {
      let marqueVehiculeVO = {
        cle: null, texte: 'Saisir la marque'
      };
      this.enregistrementEnCours = true;
      this.$store.dispatch('pilotage/ajouterMarqueAction', {
        marqueVehiculeVO: marqueVehiculeVO
      })
          .then((res) => {
            this.$emit("addMarqueFromList", res.data);
            this.enregistrementEnCours = false;
            this.$toast.add({
              severity: 'success',
              summary: 'Ajout Modèle',
              detail: "L ajout a été effectuée",
              life: 6000
            });
          })
          .catch(err => {
            this.$toast.add({
              severity: 'error',
              summary: 'Sauvegarder',
              detail: `Erreur lors de l'enregistrement du modèle: ${err}`,
              life: 6000
            })
          })
    },
    fermer() {
      this.$emit('fermer');
    }
  },
}
</script>
